import React, { useContext } from 'react'

import Page from '../../components/Page'
import MeetingMetricsReport from '../../components/sections/reportBuilder/reports/MeetingMetricsReport'
import AuthContext from '../../utils/authProvider'

const MeetingMetricsReportPage = () => {
  const breadcrumb = [
    {
      path: '/',
      breadcrumbName: 'Home'
    },
    {
      path: '',
      breadcrumbName: 'Meeting Metrics Report'
    }
  ]
  const Auth = useContext(AuthContext)
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  return (
    <>
      <Page title='Meeting Metrics Report' breadcrumb={breadcrumb}>
        <MeetingMetricsReport />
      </Page>
    </>
  )
}

export default MeetingMetricsReportPage
